import axios from 'axios';

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json',
        },
        data: params,
        traditional: true
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
    //get/delete传递参数和post/put不一样
    if(method === 'get' || method === 'delete'){
        return axios({
            method: method,
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'authorization': localStorage.getItem('logintoken')
            },
            params: params,
            traditional: true,
        }).then(res => res.data);
    } else {
        return axios({
            method: method,
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'authorization': localStorage.getItem('logintoken')
            },
            data: params,
            traditional: true,
        }).then(res => res.data);
    }

};

export {
    loginreq,
    req
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js